import CorrespondenceDashboardPage from "pages/dashboard/CorrespondenceDashboard";
import DashboardPage from "pages/dashboard/Dashboard";
import SharedDashboardPage from "pages/dashboard/SharedDashboard";
import { DASHBOARD_SHARED_SECTIONS } from "constants/constants";
import { Navigate, Route } from "react-router-dom";
const routes = {
  key: "DASHBOARD",
  routes: ({ userScope }) => [
    <Route key={"dashboard"} path={`${userScope}/dashboard`}>
      <Route key={"dashboard-page"} path="" element={<DashboardPage />} />
      <Route
        key={"dashboard-shared-redirect"}
        path={`shared`}
        element={<Navigate to={DASHBOARD_SHARED_SECTIONS.ic} replace />}
      />
      <Route
        key={"dashboard-shared"}
        path={`shared/:tab`}
        element={<SharedDashboardPage />}
      />
      <Route
        key={"dashboard-correspondence"}
        path={`correspondence`}
        element={<CorrespondenceDashboardPage />}
      />
    </Route>,
  ],
};
export default routes;
